import React from 'react';

const SetupOnboarding = React.lazy(() => import('views/setup/onboarding').then(m => ({ default: m.SetupOnboarding })));

const Routes = [
  {
    path: '/setup',
    view: SetupOnboarding,
    layout: 'onboarding',
    title: 'Welcome to Gravity',
  },
];

export default Routes;
